export interface UserModel {
  name: string;
}

export class NotificationSettingModel {
  slackWebhook: string;
  useSlack: boolean;
  mail: string;
  useMail: boolean;
  webhookUrl: string;
  useWebhook: boolean;
  webhookNotifyDataBody: string;
  webhookNotifyStatusBody: string;

  constructor() {
    this.slackWebhook = '';
    this.useSlack = false;
    this.mail = '';
    this.useMail = false;
    this.webhookUrl = '';
    this.useWebhook = false;
    this.webhookNotifyDataBody = '';
    this.webhookNotifyStatusBody = '';
  }
}

export interface NetworkModel {
  networkId: string;
  name: string;
  devices: string[];
}

export interface DeviceModel {
  deviceId: string;
  name: string;
  kind: string;
  networkId: string;
  reports: ReportModel[];
  isCandidate: boolean;
  parentId: string;
  condition: string;
  threshold: number;
}

export interface ReportModel {
  deviceId: string;
  createdAt: number;
  status: string;
}
